// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"294":"a7073844","822":"9c78fa3a"}[chunkId] + ".css";
};